/**
 * Reefer draws popover with `--border-radius-lg` (24px) on an inner
 * element it doesn't expose, rebinding to override that style.
 * Scoped to this popover.
 */
.menu {
  --border-radius-lg: var(--border-radius-sm);
}

.trigger:hover {
  background: var(--colors-grays-hover);
}
